module.exports = __webpack_public_path__ + "img/HALLOWEEN.f5ad158.svg";